<template>
  <Layout title="Buchen" h1="Buchen" :banner="$page.props.banner">
    <booking @onNext="onNext">
      <div class="row">
        <div class="col-lg-6 mb-4 mb-lg-0" v-if="form_show">
          <!-- Formular -->
          <div class="participant">
            <booking-form @submit.prevent="onSubmit()" :loading="form_saving">
              <h3 class="h6 fw-bold text-primary">
                Teilnehmer
                <template v-if="formCreate">hinzufügen</template>
                <template v-else>bearbeiten</template>
              </h3>

              <div
                class="bg-primary p-2 text-white d-md-flex justify-content-md-between align-items-md-center"
              >
                <div>Persönliches</div>
                <div class="d-flex align-items-center">
                  <div class="small me-2">
                    <span v-if="form.firstname && form.lastname"
                      >{{ form.firstname }} {{ form.lastname }}</span
                    >
                    <span v-if="form.age"> ({{ form.age }})</span>
                  </div>
                </div>
              </div>

              <div class="row gx-3 mt-1">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <label for="gender">Anrede{{ isMandatory("gender") ? "*" : ""}}</label>
                  <select
                    v-model="form.gender"
                    id="gender"
                    class="form-select rounded-0 border-0"
                    :class="{ 'is-invalid': errors.gender }"
                    :required="isMandatory('gender')"
                  >
                    <select-default>Bitte wählen</select-default>
                    <option value="H">
                      <gender gender="H" />
                    </option>
                    <option value="F">
                      <gender gender="F" />
                    </option>
                    <option value="D">
                      <gender gender="D" />
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.gender">
                    {{ errors.gender }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="birthday">Geburtstag{{ isMandatory("birthday") ? "*" : ""}}</label>
                  <input
                    type="date"
                    id="birthday"
                    class="form-control rounded-0 border-0"
                    :class="{ 'is-invalid': errors.birthday }"
                    v-model="form.birthday"
                    :placeholder="
                      'Geburtstag' + (isMandatory('birthday') ? '*' : '')
                    "
                    :required="isMandatory('birthday')"
                  />
                  <div class="invalid-feedback" v-if="errors.birthday">
                    {{ errors.birthday }}
                  </div>
                </div>
              </div>

              <div class="row gx-3 mt-3">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <input
                    type="text"
                    class="form-control rounded-0 border-0"
                    :class="{ 'is-invalid': errors.firstname }"
                    v-model="form.firstname"
                    :placeholder="
                      'Vorname' + (isMandatory('firstname') ? '*' : '')
                    "
                    maxlength="100"
                    :required="isMandatory('firstname')"
                  />
                  <div class="invalid-feedback" v-if="errors.firstname">
                    {{ errors.firstname }}
                  </div>
                </div>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control rounded-0 border-0"
                    :class="{ 'is-invalid': errors.lastname }"
                    v-model="form.lastname"
                    :placeholder="
                      'Nachname' + (isMandatory('lastname') ? '*' : '')
                    "
                    maxlength="100"
                    :required="isMandatory('lastname')"
                  />
                  <div class="invalid-feedback" v-if="errors.lastname">
                    {{ errors.lastname }}
                  </div>
                </div>
              </div>

              <div class="form-check mt-3" v-if="!formEditIsFirst">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="form.address_differs"
                  :true-value="true"
                  :false-value="false"
                  id="address-differs"
                />
                <label class="form-check-label" for="address-differs">
                  Kontaktdaten abweichend
                </label>
              </div>

              <div class="mt-3" v-if="formEditIsFirst || form.address_differs">
                <div class="row gx-3 mb-3">
                  <div class="col-sm-8 mb-3 mb-sm-0">
                    <input
                      type="text"
                      class="form-control rounded-0 border-0"
                      :class="{ 'is-invalid': errors.street }"
                      v-model="form.street"
                      :placeholder="
                        'Straße' + (isMandatory('street') ? '*' : '')
                      "
                      maxlength="255"
                      :required="isMandatory('street')"
                    />
                    <div class="invalid-feedback" v-if="errors.street">
                      {{ errors.street }}
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <input
                      type="text"
                      class="form-control rounded-0 border-0"
                      :class="{ 'is-invalid': errors.street_no }"
                      v-model="form.street_no"
                      :placeholder="
                        'Nr.' + (isMandatory('street_no') ? '*' : '')
                      "
                      maxlength="20"
                      :required="isMandatory('street_no')"
                    />
                    <div class="invalid-feedback" v-if="errors.street_no">
                      {{ errors.street_no }}
                    </div>
                  </div>
                </div>
                <div class="row gx-3 mb-3">
                  <div class="col-sm-4 mb-3 mb-sm-0">
                    <input
                      type="text"
                      class="form-control rounded-0 border-0"
                      :class="{ 'is-invalid': errors.zip }"
                      v-model="form.zip"
                      :placeholder="'PLZ' + (isMandatory('zip') ? '*' : '')"
                      maxlength="50"
                      :required="isMandatory('zip')"
                    />
                    <div class="invalid-feedback" v-if="errors.zip">
                      {{ errors.zip }}
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control rounded-0 border-0"
                      :class="{ 'is-invalid': errors.city }"
                      v-model="form.city"
                      :placeholder="'Ort' + (isMandatory('city') ? '*' : '')"
                      maxlength="255"
                      :required="isMandatory('city')"
                    />
                    <div class="invalid-feedback" v-if="errors.city">
                      {{ errors.city }}
                    </div>
                  </div>
                </div>
                <div class="row gx-3">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control rounded-0 border-0"
                        :class="{ 'is-invalid': errors.mobile }"
                        v-model="form.mobile"
                        :placeholder="
                          'Handy' + (isMandatory('mobile') ? '*' : '')
                        "
                        maxlength="50"
                        :required="isMandatory('mobile')"
                      />
                      <div class="invalid-feedback" v-if="errors.mobile">
                        {{ errors.mobile }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <div class="input-group">
                      <input
                        type="email"
                        class="form-control rounded-0 border-0"
                        :class="{ 'is-invalid': errors.email }"
                        v-model="form.email"
                        :placeholder="
                          'E-Mail' + (isMandatory('email') ? '*' : '')
                        "
                        maxlength="255"
                        :required="isMandatory('email')"
                      />
                      <div class="invalid-feedback" v-if="errors.email">
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="canIsParticipant">
                <div class="form-check mt-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="form.is_participant"
                    :true-value="false"
                    :false-value="true"
                    id="is-participant"
                  />
                  <label class="form-check-label" for="is-participant">
                    Du bist nur Ansprechpartner und kein Teilnehmer?
                    <forms-info
                      >Du buchst für andere Reisende und nimmst selbst an der
                      Reise nicht teil, dann führen wir dich als
                      Ansprechpartner.</forms-info
                    >
                  </label>
                </div>
              </template>

              <template
                v-if="isValidateDate(form.birthday) && form.is_participant"
              >
                <div class="bg-primary p-2 text-white mt-3">Leistungen</div>

                <div v-if="rooms && rooms.length" class="mt-3">
                  <select
                    v-model="form.room_id"
                    class="form-select rounded-0 border-0"
                    :class="{ 'is-invalid': errors.room_id }"
                  >
                    <select-default>Unterkunft wählen*</select-default>
                    <option
                      v-for="room in rooms"
                      :value="room.id"
                      :key="'room-' + room.id"
                    >
                      <template v-if="room.price > 0"><price :given="room.price" :digits="2" /></template>
                      <template v-else>Auf Anfrage</template>
                      - {{ room.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.room_id">
                    {{ errors.room_id }}
                  </div>
                  <div
                    v-if="selectedRoomOnRequest"
                    class="alert alert-warning mt-3 rounded-0"
                  >
                    Diese Unterkunft ist nur auf Anfrage buchbar. Bitte melde
                    dich bei uns – eine Onlinebuchung ist hier leider nicht
                    möglich.
                  </div>
                     <div
                  v-if="adult_price_but_child"
                  class="alert alert-info mt-3 rounded-0"
                >
                  Kinderfestpreis gilt nur bei Unterbringung mit 2 Vollzahlern.
                </div>
                </div>
                <div
                  v-if="!rooms || !rooms.length"
                  class="alert alert-danger mt-3 rounded-0"
                >
                  Es stehen leider keine Zimmer mehr zur Verfügung.
                </div>

                <div
                  v-if="!bus && !seperate"
                  class="alert alert-danger mt-3 rounded-0"
                >
                  Es stehen leider keine Anreisemöglichkeiten zur Verfügung.
                </div>

                <template
                  v-if="form.room_id && (bus || seperate) && !selectedRoomOnRequest"
                >
                  <label class="form-label mt-3"
                    >Anreise wählen*</label
                  >
                  <div>
                    <input
                      type="radio"
                      v-model="form.arrival"
                      class="btn-check"
                      id="arrival-bus"
                      autocomplete="off"
                      value="bus"
                      v-if="bus"
                    />
                    <label
                      class="btn btn-link text-decoration-none font-family-body"
                      :class="{
                        'text-body': form.arrival != 'bus',
                        'text-primary': form.arrival == 'bus',
                      }"
                      v-if="bus"
                      for="arrival-bus"
                      style="min-width: 5rem"
                    >
                      <arrival-icon type="bus" class="fs-2" /><br />
                      <span class="d-inline-block mt-3">Bus</span>
                    </label>
                    <input
                      type="radio"
                      v-model="form.arrival"
                      class="btn-check"
                      id="arrival-seperate"
                      autocomplete="off"
                      value="seperate"
                      v-if="seperate"
                    />
                    <label
                      class="btn btn-link text-decoration-none font-family-body"
                      :class="{
                        'text-body': form.arrival != 'seperate',
                        'text-primary': form.arrival == 'seperate',
                      }"
                      for="arrival-seperate"
                      style="min-width: 5rem"
                      v-if="seperate"
                    >
                      <arrival-icon type="seperate" class="fs-2" /><br />
                      <span class="d-inline-block mt-3">Eigenanreise</span>
                    </label>
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="errors.arrival"
                    :class="{ 'd-block': errors.arrival }"
                  >
                    {{ errors.arrival }}
                  </div>

                  <div v-if="form.arrival == 'seperate'">
                    <div class="alert alert-primary rounded-0">
                      Bei eigener Anreise steht das Zimmer einen Tag später am
                      {{
                        travelDateFromSeperate.toLocaleDateString("de-DE", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                      }}
                      zur Verfügung.
                    </div>
                    <div class="row gx-3">
                      <div class="col">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control rounded-0 border-0"
                            :class="{ 'is-invalid': errors.mobile }"
                            v-model="form.mobile"
                            :placeholder="
                              'Handy' + (isMandatory('mobile') ? '*' : '')
                            "
                            maxlength="50"
                            :required="isMandatory('mobile')"
                          />
                          <div class="invalid-feedback" v-if="errors.mobile">
                            {{ errors.mobile }}
                          </div>
                        </div>
                        <div class="form-text">
                          Für kurzfristige Rückfragen benötigen wir eine
                          Handynummer.
                        </div>
                      </div>
                    </div>
                  </div>

                  <template v-if="form.arrival">
                    <div
                      v-if="
                        boardings &&
                        boardings.length &&
                        form.arrival != 'seperate'
                      "
                      class="mt-3"
                    >
                      <select
                        v-model="form.boarding_id"
                        class="form-select rounded-0 border-0"
                        :class="{ 'is-invalid': errors.boarding_id }"
                      >
                        <select-default>Zustieg auswählen*</select-default>
                        <option
                          v-for="boarding in boardings"
                          :value="boarding.id"
                          :key="'ski-pass-' + boarding.id"
                        >
                          {{ formatBoardingDate(boarding.get_on) }}
                          - {{ boarding.node_description }} -
                          {{ boarding.description }} - Zuschlag:
                          <price :given="boarding.extra_amount" :digits="2" />
                        </option>
                      </select>
                      <div class="invalid-feedback" v-if="errors.boarding_id">
                        {{ errors.boarding_id }}
                      </div>
                      <div
                        class="form-text"
                        v-if="
                          selectedBoarding &&
                          !hasBoardingTime(selectedBoarding.get_on)
                        "
                      >
                        Die genaue Uhrzeit teilen wir euch rechtzeitig mit.
                      </div>
                    </div>

                    <div id="arrival-bus-extra" v-if="form.arrival == 'bus'">
                      <div
                        class="form-check mt-1"
                        v-if="busRelax && busRelax.id"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :class="{ 'is-invalid': errors.arrival_bus_relax_id }"
                          v-model="form.arrival_bus_relax_id"
                          :true-value="busRelax.id"
                          :false-value="null"
                          id="arrival-bus-relax"
                        />
                        <label class="form-check-label" for="arrival-bus-relax">
                          Relax-Sessel für
                          <price :given="busRelax.price" :digits="2" />
                        </label>
                        <div
                          class="invalid-feedback"
                          v-if="errors.arrival_bus_relax_id"
                        >
                          {{ errors.arrival_bus_relax_id }}
                        </div>
                      </div>
                    </div>
                    <div
                      id="arrival-train-extra"
                      v-if="form.arrival == 'train'"
                    >
                      <div v-if="trainUexs && trainUexs.length" class="mt-3">
                        <select
                          v-model="form.arrival_train_uex_id"
                          class="form-select rounded-0 border-0"
                          :class="{ 'is-invalid': errors.arrival_train_uex_id }"
                        >
                          <select-default
                            >Optional: UEX-Zuschlag</select-default
                          >
                          <option
                            v-for="trainUex in trainUexs"
                            :value="trainUex.id"
                            :key="'arrival-train-uex-' + trainUex.id"
                          >
                            {{ trainUex.name }} - Zuschlag:
                            <price :given="trainUex.price" :digits="2" />
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.arrival_train_uex_id"
                        >
                          {{ errors.arrival_train_uex_id }}
                        </div>
                      </div>
                    </div>
                    <div v-if="!skiPasses.length" class="alert alert-primary rounded-0 mt-3">
                        Kinder unter {{ skiPassesYoungest }} Jahren benötigen keinen Skipass.
                    </div>
                    <div v-if="skiPasses && skiPasses.length" class="mt-3">
                      <select
                        v-model="form.ski_pass_id"
                        class="form-select rounded-0 border-0"
                        :class="{ 'is-invalid': errors.ski_pass_id }"
                      >
                        <select-default>Skipass wählen</select-default>
                        <option
                          v-for="ski_pass in skiPasses"
                          :value="ski_pass.id"
                          :key="'ski-pass-' + ski_pass.id"
                        >
                          <price :given="ski_pass.price" :digits="2" /> -
                          {{ ski_pass.name }}
                        </option>
                      </select>
                      <div class="invalid-feedback" v-if="errors.ski_pass_id">
                        {{ errors.ski_pass_id }}
                      </div>
                      <div v-if="!form.ski_pass_id" class="form-text">
                        Laut Teilnahmebedingungen weisen wir darauf hin, dass
                        eine Betreuung durch unsere Reiseleitung nur dann
                        gewährleistet ist, wenn eine Buchung mit Skipass
                        erfolgt.
                      </div>
                      <div v-if="form.key_card_id" class="form-text">
                        KeyCardPfand:
                        <price :given="keyCard.price" :digits="2" />
                      </div>
                    </div>

                    <div class="form-check mt-3" v-if="skiSchool">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :class="{ 'is-invalid': errors.ski_school_id }"
                        v-model="form.ski_school_id"
                        :true-value="skiSchool.id"
                        :false-value="null"
                        id="ski-school"
                      />
                      <label class="form-check-label" for="ski-school">
                        Skischule für
                        <price :given="skiSchool.price" :digits="2" /><br />
                        <span class="text-muted"
                          ><small v-html="skiSchool.name"></small
                          ></span
                        >
                      </label>
                      <div class="invalid-feedback" v-if="errors.ski_school_id">
                        {{ errors.ski_school_id }}
                      </div>
                    </div>

                    <div class="form-check mt-3" v-if="skiRental">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :class="{ 'is-invalid': errors.ski_rental_id }"
                        v-model="form.ski_rental_id"
                        :true-value="skiRental.id"
                        :false-value="null"
                        id="ski-rental"
                      />
                      <label class="form-check-label" for="ski-rental">
                        Skiverleih für
                        <price :given="skiRental.price" :digits="2" /><br />
                        <span class="text-muted"
                          ><small>7 Tage Skiverleih Bronze</small></span
                        >
                      </label>
                      <div class="invalid-feedback" v-if="errors.ski_rental_id">
                        {{ errors.ski_rental_id }}
                      </div>
                    </div>

                    <!-- Eigene Rechnung -->
                    <template v-if="!formEditIsFirst">
                      <label for="invoice" class="form-label mt-3 mb-1">
                        Eigene Rechnung?
                      </label>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="form.invoice"
                          :true-value="true"
                          :false-value="false"
                          id="invoice"
                        />
                        <label class="form-check-label" for="invoice">
                          gewünscht
                        </label>
                      </div>
                    </template>

                    <textarea
                      v-model="form.note"
                      class="form-control rounded-0 border-0 mt-3"
                      rows="4"
                      placeholder="Hinweise (Allergien, Skipass, etc.)"
                      @blur="syncModel()"
                    ></textarea>
                  </template>
                </template>
              </template>

              <div
                v-if="formPrice"
                class="d-flex justify-content-between bg-light-grey p-2 mt-3"
              >
                <div>Preis Teilnehmer:</div>
                <div class="text-end">
                  <strong>
                    <price :given="formPrice" :digits="2" />
                  </strong>
                </div>
              </div>
              <div v-if="!formSaveable" class="text-muted ps-2">
                <small>Bitte alle Pflichtfelder ausfüllen.</small>
              </div>
              <div class="d-flex justify-content-between mt-3">
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary rounded-pill"
                    @click="toggleFormShow(false)"
                  >
                    <i class="fa-solid fa-xmark"></i>Schließen
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    class="btn btn-sm btn-primary rounded-pill"
                    name="addParticipant"
                    :disabled="form.processing || !formSaveable || selectedRoomOnRequest"
                  >
                    <i class="fa-solid fa-floppy-disk"></i>Speichern
                  </button>
                </div>
              </div>
            </booking-form>
          </div>
        </div>
        <div class="col">
          <!-- List participants -->
          <h3 class="h6 fw-bold text-primary">
            Teilnehmerliste
            <span v-if="participantsCount">({{ participantsCount }})</span>
          </h3>
          <div class="bg-primary text-white p-2 d-flex justify-content-between">
            <div v-if="bookingForm">
              {{ bookingForm.travel_date.days }}
              {{ bookingForm.travel_date.days > 1 ? "Tage" : "Tag"
              }}{{
                bookingForm.participants_adult_count ||
                bookingForm.participants_child_count
                  ? ","
                  : ""
              }}
              <span v-if="bookingForm.participants_adult_count"
                >{{ bookingForm.participants_adult_count }}
                {{
                  bookingForm.participants_adult_count > 1
                    ? "Erwachsene"
                    : "Erwachsener"
                }}</span
              >{{
                bookingForm.participants_adult_count &&
                bookingForm.participants_child_count
                  ? ","
                  : ""
              }}
              <span v-if="bookingForm.participants_child_count"
                >{{ bookingForm.participants_child_count }}
                {{
                  bookingForm.participants_child_count > 1 ? "Kind" : "Kinder"
                }}</span
              >
            </div>
            <div class="text-end" v-if="bookingForm && bookingForm.price">
              <strong>
                <price :given="bookingForm.price" :digits="2" />
              </strong>
            </div>
          </div>
          <div
            class="booking-participant-show p-2"
            :class="{ 'border-bottom border-dark': participantsCount }"
            v-if="!bookingForm.booker_is_participant"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>Ansprechpartner</strong>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-edit m-0"
                  @click="editBooker()"
                >
                  <i class="fa-solid fa-pen m-0"></i>
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <div>
                <small>
                  <gender :gender="booker.gender" /> {{ booker.lastname }},
                  {{ booker.firstname }}
                </small>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-link btn-sm text-decoration-none p-0 m-0"
                  @click="onBookerDetails()"
                >
                  Details
                  <i
                    class="fa-solid fa-chevron-left m-0"
                    v-if="booker_details"
                  ></i>
                  <i class="fa-solid fa-chevron-down m-0" v-else></i>
                </button>
              </div>
            </div>
            <div class="details" v-if="booker_details">
              <div class="border-top py-3 fs-small">
                <div v-if="booker.birthday">
                  {{
                    new Date(booker.birthday).toLocaleDateString("de-DE", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                  }}
                </div>
                <div v-if="booker.address">{{ booker.address }}</div>
                <div v-if="booker.mobile || booker.email">
                  <span v-if="booker.mobile">{{ booker.mobile }}</span
                  ><span v-if="booker.mobile && booker.email">, </span>
                  <span v-if="booker.email">{{ booker.email }}</span>
                </div>
              </div>
              <div class="border-top py-3 text-end">
                <confirm-delete
                  :btn-attrs="{
                    class: 'btn btn-link btn-sm text-decoration-none text-body',
                  }"
                  @confirmed="removeBooker()"
                >
                  <i class="fa-solid fa-trash"></i> Entfernen
                  <template #confirm-header>Ansprechpartner löschen?</template>
                </confirm-delete>
              </div>
            </div>
          </div>
          <template v-if="participants">
            <div
              class="booking-participant-show p-2"
              v-for="(participant, index) in participants"
              :key="'booking-participant-show-' + index"
              :class="{
                'border-bottom border-dark': index + 1 < participantsCount,
              }"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <strong
                    >Teilnehmer {{ parseInt(index) + 1 }}
                    <span
                      v-if="index == 0 && !hasBooker"
                      class="badge bg-primary rounded-pill"
                      >Ansprechpartner</span
                    ></strong
                  >
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-edit m-0"
                    @click="editParticipant(index)"
                  >
                    <i class="fa-solid fa-pen m-0"></i>
                  </button>
                </div>
              </div>
              <div
                class="d-flex justify-content-between align-items-center mt-1"
                v-if="participant.firstname && participant.lastname"
              >
                <div class="fs-small">
                  <gender :gender="participant.gender" />
                  {{ participant.lastname }}, {{ participant.firstname }}
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-link btn-sm text-decoration-none p-0 m-0"
                    @click="onParticipantDetails(index)"
                  >
                    Details
                    <i
                      class="fa-solid fa-chevron-left m-0"
                      v-if="participantDetailsOpened(index)"
                    ></i>
                    <i class="fa-solid fa-chevron-down m-0" v-else></i>
                  </button>
                </div>
              </div>
              <div class="details" v-if="participantDetailsOpened(index)">
                <div class="border-top py-3 fs-small">
                  <div v-if="participant.birthday">
                    {{
                      new Date(participant.birthday).toLocaleDateString(
                        "de-DE",
                        { day: "2-digit", month: "2-digit", year: "numeric" }
                      )
                    }}
                  </div>
                  <div v-if="participant.address">
                    {{ participant.address }}
                  </div>
                  <div v-if="participant.mobile || participant.email">
                    <span v-if="participant.mobile">{{
                      participant.mobile
                    }}</span
                    ><span v-if="participant.mobile && participant.email"
                      >,
                    </span>
                    <span v-if="participant.email">{{
                      participant.email
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="participant.room"
                  class="fs-small border-top py-3 d-flex justify-content-between"
                >
                  <div><strong>Unterkunft</strong></div>
                  <div class="text-end">{{ participant.room.name }}</div>
                </div>
                <div
                  v-if="participant.arrival"
                  class="fs-small border-top py-3 d-flex justify-content-between"
                >
                  <div><strong>Anreise</strong></div>
                  <div class="text-end">
                    <div>
                      <arrival-icon :type="participant.arrival" />
                      {{ participant.arrival_readable }}
                    </div>
                    <div v-if="participant.boarding">
                      <small
                        >Zustieg:
                        {{ participant.boarding.node_description }}</small
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-if="participant.ski_pass"
                  class="fs-small border-top py-3 d-flex justify-content-between"
                >
                  <div><strong>Skipass</strong></div>
                  <div class="text-end">{{ participant.ski_pass.name }}</div>
                </div>
                <div
                  v-if="participant.price"
                  class="fs-small border-top py-3 d-flex justify-content-between"
                >
                  <div><strong>Preis</strong></div>
                  <div class="text-end fw-bold">
                    <price :given="participant.price" />
                  </div>
                </div>
                <div
                  v-if="participant.note"
                  class="fs-small border-top py-3 d-flex justify-content-between"
                >
                  <div><strong>Hinweise</strong></div>
                  <div class="text-end">{{ participant.note }}</div>
                </div>
                <div v-if="index > 0" class="border-top py-3 text-end">
                  <confirm-delete
                    :btn-attrs="{
                      class:
                        'btn btn-link btn-sm text-decoration-none text-body',
                    }"
                    @confirmed="removeParticipant(index)"
                  >
                    <i class="fa-solid fa-trash"></i> Entfernen
                    <template #confirm-header>Teilnehmer löschen?</template>
                  </confirm-delete>
                </div>
              </div>
            </div>
          </template>
          <button
            v-if="model && participantsCount < model.PARTICIPANTS_MAX"
            type="button"
            class="btn btn-outline-primary rounded-pill mt-3"
            @click="createNewParticipant()"
          >
            <i class="fa-solid fa-plus"></i> Neuer Teilnehmer
          </button>
          <!-- <div
            class="invalid-feedback"
            v-if="errors.participants"
            :class="{ 'd-block': errors.participants }"
          >
            {{ errors.participants }}
          </div> -->
        </div>
      </div>
    </booking>
  </Layout>
</template>
<script>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Booking";
import Booking from "./Booking";
import BookingForm from "./Form";
import BookingFormModel from "../../Models/BookingFormModel";
import Travel from "../../Models/Travel";
import TravelDate from "../../Models/TravelDate";
import Gender from "../../Components/Scol/Gender";
import Price from "../../Components/Scol/Price";
import ArrivalIcon from "../../Components/Scol/ArrivalIcon";
import ConfirmDelete from "../../Components/Scol/ConfirmDelete";
import FormsInfo from "../../Components/Forms/Info";
import SelectDefault from "../../Components/Forms/SelectDefault";
import Spinner from "../../Components/Scol/Spinner";
import { store } from "../../store";

export default {
  components: {
    Layout,
    Link,
    Booking,
    BookingForm,
    Gender,
    Price,
    ArrivalIcon,
    ConfirmDelete,
    FormsInfo,
    SelectDefault,
    Spinner,
  },
  props: {
    errors: Object,
    bookingForm: Object,
    messages: Object,
  },
  data: () => ({
    watchers_enabled: false,
    form: useForm({
      // show: true,
      index: null,
      gender: null,
      birthday: null,
      age: null,
      firstname: null,
      lastname: null,
      address_differs: false,
      street: null,
      street_no: null,
      zip: null,
      city: null,
      email: null,
      mobile: null,
      room_id: null,
      arrival: null,
      arrival_bus_relax_id: null,
      arrival_train_uex_id: null,
      boarding_id: null,
      ski_pass_id: null,
      key_card_id: null,
      ski_school_id: null,
      ski_rental_id: null,
      selfdrive_discount_id: null,
      invoice: false,
      is_participant: true,
      note: null,
    }),
    booker_details: false,
    participants_details: [],
    form_watch: false,
    form_show: false,
    form_saving: false,
    participant_edit: false,
    store,
  }),
  watch: {
    "form.birthday"(value) {
      let update = false;
      if (!value) {
        // Empty date > reload
        update = true;
      }
      if (!update) {
        // Valid date > reload
        if (this.isValidateDate(value)) {
          update = true;
        }
      }
      if (this.watchersEnabled() && update) {
        // console.log('WATCH form.birthday endabled');
        this.formReset(["age", "room_id", "boarding_id", "ski_pass_id"]);
        this.syncModel(true);
      }
    },
    room_id(value) {
      console.log(value);
      if (!this.form.room_id && value) {
        this.form.room_id = value;
      }
    },
    "form.room_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.room_id endabled');
        this.syncModel(true);
      }
    },
    "form.arrival"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.arrival endabled');
        if (value != "seperate") {
          this.formReset([
            "boarding_id",
            "arrival_bus_relax_id",
            "arrival_train_uex_id",
          ]);
        }
        this.syncModel(true, {
          onFinish: () => {
            // Add boarding on seperate arrival
            if (value == "seperate") {
              this.form.selfdrive_discount_id = _.get(this.selfdriveDiscount, "id");

              this.form.boarding_id = _.get(
                this.bookingForm,
                "data.participant_new.boarding_id"
              );
              if (!this.form.boarding_id) {
                console.log("Ratio: Boarding missing.");
              }
              this.formReset(["arrival_bus_relax_id", "arrival_train_uex_id"]);
            } else {
              this.formReset(["selfdrive_discount_id"]);
            }
          },
        });
      }
    },
    "form.arrival_bus_relax_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.arrival_bus_relax_id endabled');
        this.syncModel(true);
      }
    },
    "form.arrival_train_uex_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.arrival_train_uex_id endabled');
        this.syncModel(true);
      }
    },
    "form.boarding_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.boarding_id endabled');
        this.syncModel(true);
      }
    },
    "form.ski_pass_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.ski_pass_id endabled');
        this.syncModel(true, {
          onFinish: () => {
            // Add key card if ski pass filled
            if (value) {
              this.form.key_card_id = _.get(this.keyCard, "id");
              if (!this.form.key_card_id) {
                console.log("Ratio: KeyCard missing.");
              }
            } else {
              this.form.key_card_id = null;
            }
          },
        });
      }
    },
    "form.ski_school_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.ski_school_id endabled');
        this.syncModel(true);
      }
    },
    "form.ski_rental_id"(value) {
      if (this.watchersEnabled()) {
        // console.log('WATCH form.ski_rental_id endabled');
        this.syncModel(true);
      }
    },
    "form.invoice"(value) {
      if (this.watchersEnabled() && value) {
        // console.log('WATCH form.invoice endabled');
        this.form.address_differs = true;
      }
    },
  },
  methods: {
    // Zustiege ohne hinterlegte Uhrzeit (00:00) nur mit Datum anzeigen
    hasBoardingTime(getOn) {
      const date = new Date(getOn);
      return date.getHours() !== 0 || date.getMinutes() !== 0;
    },
    formatBoardingDate(getOn) {
      const date = new Date(getOn);
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      if (this.hasBoardingTime(getOn)) {
        options.hour = "2-digit";
        options.minute = "2-digit";
      }
      return date.toLocaleDateString("de-DE", options);
    },
    syncModel(reload = false, callback) {
      let newParticipant = {};
      const allowed = BookingFormModel.participantProperties();
      allowed.forEach((key) => {
        newParticipant[key] = this.form[key];
      });
      // console.log(newParticipant);
      return this.model
        .set("participant_new", newParticipant)
        .toStorage()
        .syncToServer()
        .then(() => {
          if (reload) {
            this.reloadOnly(callback);
          }
        });
    },
    createNewParticipant() {
      this.disableWatchers();
      this.participant_edit = false;
      this.model
        .delete("participant_new")
        .toStorage()
        .syncToServer()
        .then(() => {
          this.formReset();
          this.reloadOnly({
            onSuccess: () => {
              this.enableWatchers();
            },
          });
        });
      this.toggleFormShow(true);
    },
    editBooker() {
      this.participant_edit = true;

      // Dsiable watchers to control page reload
      this.disableWatchers();

      this.formReset();
      this.form.index = null;
      const booker = this.model.get("booker");
      BookingFormModel.bookerProperties().forEach((key) => {
        this.form[key] = typeof booker[key] == "undefined" ? null : booker[key];
      });
      this.form.is_participant = false;

      // Sync
      this.syncModel(true).then(() => {
        this.enableWatchers();
      });
      this.toggleFormShow(true);
    },
    editParticipant(index) {
      this.participant_edit = true;

      // Dsiable watchers to control page reload
      this.disableWatchers();

      this.formReset();
      this.form.index = index;
      const participant = _.get(this.bookingForm, `data.participants.${index}`);
      BookingFormModel.participantProperties().forEach((key) => {
        this.form[key] =
          typeof participant[key] == "undefined" ? null : participant[key];
      });
      if (
        this.form.index != 0 &&
        (this.form.street ||
          this.form.street_no ||
          this.form.zip ||
          this.form.city ||
          this.form.email)
      ) {
        this.form.address_differs = true;
      }

      // Alte
      const data = this.form.data();

      // Sync and reload
      this.syncModel(true).then(() => {
        // Properties need reload to find in select
        this.form.room_id = data.room_id;
        this.form.boarding_id = data.boarding_id;
        this.form.ski_pass_id = data.ski_pass_id;
        // this.form.defaults(); TODO: defaults method nutzen, dann kann die formReset überarbeitet werden und form is dirty funtkioniert

        this.enableWatchers();
      });
      this.toggleFormShow(true);
    },
    onSubmit(nextOnSuccess) {
      if (this.selectedRoomOnRequest) {
        this.$toast.error(
          "Diese Unterkunft ist nur auf Anfrage buchbar. Bitte melde dich bei uns – eine Onlinebuchung ist hier leider nicht möglich."
        );
        store.loading = false;
        return;
      }
      if (!this.form.is_participant) {
        this.onBooker(nextOnSuccess);
      } else {
        this.onAddParticipant(nextOnSuccess);
      }
    },
    onAddParticipant(nextOnSuccess) {
      this.form_saving = true;
      this.form
        .transform((data) => ({
          ...data,
          index: data.index == null ? this.formIndexNext : data.index,
          price: this.formPrice,

          // Boolean required
          address_differs: !!data.address_differs,
          invoice: this.formEditIsFirst ? true : !!data.invoice,
        }))
        .post(
          this.$route("booking.step2.add-participant", {
            travelDate: this.travelDate.get("slug"),
          }),
          {
            preserveScroll: true,
            data: {
              t: this.$session.tab_id,
            },
            onSuccess: (data) => {
              if (this.formCreate || this.form.index == null) {
                // Create
                this.model.addParticipant(this.form, this.formPrice);
                if (!this.formCreate) {
                  this.removeBooker();
                }
              } else {
                // Edit
                this.model.editParticipant(
                  this.form.index,
                  this.form,
                  this.formPrice
                );
              }

              console.log("SAVED");

              this.participant_edit = false;
              this.createNewParticipant();
              this.toggleFormShow(false);

              if (nextOnSuccess == true) {
                this.onNext();
            }
            },
            onFinish: () => {
              this.form_saving = false;
            },
            onError: (errors) => {
              console.log("FAILED");
              for (const [key, value] of Object.entries(
                this.$inertia.page.props.errors
              )) {
                this.$toast.error(value);
              }
            },
          }
        );
    },
    onBooker(nextOnSuccess) {
      this.form_saving = true;
      this.form.post(
        this.$route("booking.step2.booker", {
          travelDate: this.travelDate.get("slug"),
        }),
        {
          preserveScroll: true,
          data: {
            t: this.$session.tab_id,
          },
          onSuccess: (data) => {
            this.model.booker(this.form);

            // console.log("SAVED");

            if (!this.formCreate) {
              this.removeParticipant(this.form.index);
            }
            this.participant_edit = false;
            this.createNewParticipant();

            if (nextOnSuccess == true) {
                this.onNext();
            }
          },
          onFinish: () => {
            this.form_saving = false;
          },
        }
      );
    },
    removeBooker() {
      this.form_saving = true;
      if (this.formEditIsBooker) {
        this.formReset();
        this.form.index = null;
      }
      this.model
        .delete("booker")
        .toStorage()
        .syncToServer()
        .then(() => {
          this.reloadOnly({
            onFinish: () => {
              this.form_saving = false;
            },
          });
        });
    },
    removeParticipant(index) {
      this.form_saving = true;
      // if (index < 1) {
      //     return;
      // }
      // if (index == this.form.index) {
      //     this.formReset();
      //     this.form.index = null;
      // }
      this.model
        .removeParticipant(index)
        .toStorage()
        .syncToServer()
        .then(() => {
          this.reloadOnly({
            onFinish: () => {
              this.form_saving = false;
            },
          });
        });
    },
    onBookerDetails() {
      this.booker_details = !this.booker_details;
    },
    onParticipantDetails(index) {
      if (!_.includes(this.participants_details, index)) {
        this.participants_details.push(index);
      } else {
        const postition = this.participants_details.indexOf(index);
        if (postition > -1) {
          // only splice array when item is found
          this.participants_details.splice(postition, 1); // 2nd parameter means remove one item only
        }
      }
    },
    participantDetailsOpened(index) {
      return _.includes(this.participants_details, index);
    },
    loadPerson(person) {
      this.disableWatchers();
      const skip = ["index"];
      const allowed = BookingFormModel.participantProperties();
      allowed.forEach((key) => {
        if (!skip.includes(key) && person[key] !== undefined) {
          this.form[key] = person[key];
        }
      });
      this.syncModel(true).then(() => this.enableWatchers());
    },
    onNext() {
      if (this.form_show == true) {
        this.onSubmit(true);
        store.loading = false;
      } else {
        store.loading = true;
        this.model
          .delete("participant_new")
          .toStorage()
          .syncToServer()
          .then(() => {
            this.$inertia.visit(
              this.$route("booking.step3", this.bookingForm.travel_date.slug),
              {
                preserveScroll: true,
                data: {
                  t: this.$session.tab_id,
                },
                onFinish: () => {
                  store.loading = false;
                },
                onError: (errors) => {
                  for (const [key, value] of Object.entries(
                    this.$inertia.page.props.errors
                  )) {
                    this.$toast.error(value);
                  }
                },
              }
            );
          });
      }
    },
    reloadOnly(options) {
      // console.log("Reload");
      // console.log(options);
      options = {
        ...{
          data: { t: this.$session.tab_id },
        },
        ...options,
      };
      // console.log(options);
      // console.trace();
      this.$inertia.reload(options);
    },
    formReset(properties) {
      let log = "Form reseted";

      if (!properties) {
        // this.form.reset();
        properties = BookingFormModel.participantProperties();
        properties.push("is_participant");
        log += ": ALL";
      } else {
        // this.form.reset(properties);
        log += ": " + properties.join(",");
      }

      // Form properties set to null
      let data = {};
      properties.forEach((key) => {
        switch (key) {
          case "address_differs":
          case "invoice":
            data[key] = false;
            break;
          case "is_participant":
            data[key] = true;
            break;

          default:
            data[key] = null;
            break;
        }
      });

      this.form = { ...this.form, ...data };

      // console.log(log);
    },
    isMandatory(fieldname) {
      return this.mandatoryFields.includes(fieldname);
    },
    enableWatchers() {
      this.watchers_enabled = true;
    },
    disableWatchers() {
      this.watchers_enabled = false;
    },
    watchersEnabled() {
      return this.watchers_enabled == true;
    },
    toggleFormShow(checked) {
      this.form_show = checked;
    },
    isValidateDate(date) {
      if (!date) {
        return false;
      }
      date = new Date(date);
      const year = new Date().getFullYear() - 150;
      const min = new Date(year + "-01-01");
      if (
        date instanceof Date &&
        !isNaN(date) &&
        date > min &&
        date <= new Date()
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.participantsCount == 0) {
      this.toggleFormShow(true);
    }
    this.enableWatchers();
  },
  computed: {
    model() {
      return BookingFormModel.make(this.bookingForm).setSession(this.$session);
    },
    travelDate() {
      if (!_.get(this.bookingForm, "travel_date")) {
        return null;
      }
      return new TravelDate(this.bookingForm.travel_date);
    },
    travelDateFromSeperate() {
      let tomorrow = new Date(this.travelDate.from.getTime());
      tomorrow.setDate(this.travelDate.from.getDate() + 1);
      return tomorrow;
    },
    travel() {
      if (!_.get(this.bookingForm, "travel")) {
        return null;
      }
      return new Travel(this.bookingForm.travel);
    },
    participants() {
      return _.get(this.bookingForm, "participants", []);
    },
    participantsCount() {
      return _.get(this.bookingForm, "participants_count", 0);
    },
    hasBooker() {
      return _.get(this.bookingForm, "booker.birthday", false);
    },
    booker() {
      if (!this.hasBooker) {
        return null;
      }

      return this.bookingForm.booker;
    },
    rooms() {
      return _.get(this.bookingForm, "participant_form_data.rooms");
    },
    selectedRoomOnRequest() {
      if (!this.form.room_id || !this.rooms) {
        return false;
      }
      const room = this.rooms.find((r) => r.id == this.form.room_id);
      return room ? !(room.price > 0) : false;
    },
    room_id() {
      return _.get(this.bookingForm, "participant_form_data.room_id");
    },
    bus() {
      return _.get(this.bookingForm, "participant_form_data.bus");
    },
    train() {
      return _.get(this.bookingForm, "participant_form_data.train");
    },
    seperate() {
      return _.get(this.bookingForm, "participant_form_data.seperate");
    },
    boardings() {
      return _.get(this.bookingForm, "participant_form_data.boardings");
    },
    boarding() {
      return _.get(this.bookingForm, "participant_form_data.boarding");
    },
    selectedBoarding() {
      return _.find(this.boardings, (b) => b.id == this.form.boarding_id);
    },
    busRelax() {
      return _.get(this.bookingForm, "participant_form_data.busRelax");
    },
    trainUexs() {
      return _.get(this.bookingForm, "participant_form_data.trainUexs");
    },
    skiPasses() {
      return _.get(this.bookingForm, "participant_form_data.skiPasses");
    },
    skiPassesYoungest() {
      return _.get(this.bookingForm, "participant_form_data.skiPassesYoungest");
    },
    keyCard() {
      return _.get(this.bookingForm, "participant_form_data.keyCard");
    },
    selfdriveDiscount() {
      return _.get(this.bookingForm, "participant_form_data.selfdriveDiscount");
    },
    skiSchool() {
      return _.get(this.bookingForm, "participant_form_data.skiSchool");
    },
    skiRental() {
      return _.get(this.bookingForm, "participant_form_data.skiRental");
    },
    formPrice() {
      return _.get(this.bookingForm, "participant_form_data.price");
    },
    persons() {
      return _.get(this.bookingForm, "participant_form_data.persons");
    },
    adult_price_but_child() {
      return _.get(this.bookingForm, "participant_form_data.adult_price_but_child");
    },
    formIndexNext() {
      return this.participantsCount;
    },
    formCreate() {
      return !this.participant_edit;
    },
    formEditIsFirst() {
      return this.form.index == 0 || !this.participantsCount;
    },
    formEditIsBooker() {
      if (!this.hasBooker) {
        return false;
      }
      if (this.form.firstname != _.get(this.bookingForm, "booker.firstname")) {
        return false;
      }
      if (this.form.lastname != _.get(this.bookingForm, "booker.lastname")) {
        return false;
      }
      if (this.form.birthday != _.get(this.bookingForm, "booker.birthday")) {
        return false;
      }

      return true;
    },
    mandatoryFields() {
      // Mandatory fields
      let mandatory = ["gender", "birthday", "firstname", "lastname"];

      if (this.formEditIsFirst || this.form.address_differs) {
        mandatory.push("street", "street_no", "zip", "city");
      }

      if (this.formEditIsFirst || this.form.invoice) {
        mandatory.push("email");
      }

      if (this.formEditIsFirst || this.form.invoice) {
        mandatory.push("mobile");
      }

      if (this.form.is_participant) {
        mandatory.push(["room_id", "arrival", "boarding_id"]);
      }

      return mandatory;
    },
    formSaveable() {
      return true;
      // const mandatory = this.mandatoryFields;
      // let saveable = true;
      // mandatory.forEach((key) => {
      //     if (this.form[key] == null) {
      //         saveable = false;
      //     }
      // });

      // return saveable;
    },
    canIsParticipant() {
      return true;
      return this.formEditIsBooker;
    },
  },
};
</script>
